import React from 'react';
import { UseFieldArrayRemove } from 'react-hook-form';
import { Icon } from '../../Icon';
import { Button } from 'reactstrap';

interface PropTypes {
  filenameAccessor: string;
  fields: any[];
  remove: UseFieldArrayRemove;
}

export function FilesList(props: PropTypes) {
  if (props.fields.length === 0) return null;

  return (
    <div className='bg-gray p-3 mt-2h rounded fs-5 d-flex flex-column gap-2'>
      {props.fields.map((field, index) => (
        <div key={field.id} className='d-flex'>
          <div className='d-flex w-90'>
            <Icon name={'bi-paperclip'} className='pe-2' />
            <span className='text-truncate'>
              {field[props.filenameAccessor]}
            </span>
          </div>
          <Button
            color='borderless'
            size='sm'
            className='ms-auto'
            onClick={() => props.remove(index)}
          >
            <Icon name='bi-trash' />
          </Button>
        </div>
      ))}
    </div>
  );
}
